import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DebtsPage } from '@/features/beneficiaries/employees/debts/components/DebtsPage';

const searchSchema = z.object({
  columnFilters: z
    .array(
      z.object({
        id: z.string(),
        value: z.unknown(),
      })
    )
    .optional(),
});

export const Route = createFileRoute('/$commiteeSlug/beneficiaries/debts/')({
  component: DebtsPage,
  validateSearch: searchSchema,
});
